import { authClient, API } from "../index";

// Get all backtestingConfigs
export const getBacktestingConfigs = () => {
  return authClient().get(`${API}/backtesting-config?getDisabled=true`);
};

// Get backtestingConfig by id
export const getBacktestingConfigById = (id) => {
  return authClient().get(`${API}/backtesting-config/${id}`);
};

// Delete backtestingConfig
export const deleteBacktestingConfig = (id) => {
  return authClient().delete(`${API}/backtesting-config/${id}`);
};

// Create backtestingConfig
export const postBacktestingConfig = async (backtestingConfig) => {
  return authClient().post(`${API}/backtesting-config`, backtestingConfig);
};

// Update backtestingConfig
export const updateBacktestingConfig = async (id, backtestingConfig) => {
  return authClient().put(`${API}/backtesting-config/${id}`, backtestingConfig);
};

// Change status backtestingConfig
export const changeStatusBacktestingConfig = async (id, active) => {
  console.log("id", id, "active", active);
  return authClient().put(`${API}/backtesting-config/change-status/${id}`, { active });
};

// Get backtestingConfig by id
export const startBacktesting = (id) => {
  return authClient().get(`${API}/backtesting-config/start-backtesting/${id}`);
};